import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { useQuery } from 'react-apollo';
import ReactTooltip from 'react-tooltip';
import {
  UncontrolledCollapse, UncontrolledDropdown, DropdownToggle, DropdownMenu,
} from 'reactstrap';
import ReactImageFallback from 'react-image-fallback';
import {
  capitalizeEveryWord, FALLBACK_ICON, OFFER_DETAIL_LISTING, NUMERIC_VALUE, formatedCurrency,
} from '../../../../utils';
import { GET_REJECTED_ARTIST_LIST } from '../../../../graphql-client/queries';
import { ArtistDetail } from '../../../modals';

function RejectedArtistList(props) {
  const [artistDetailModal, setArtistDetailModal] = useState(null);
  const [artistDetailModalObj, setArtistDetailModalObj] = useState(null);
  const { offerId, searchKey, listingCount } = props;
  const [collapseRejectedClass, setRejectedCollapseClass] = useState(false);
  const [defaultResults, setDefaultResults] = useState([]);
  const [filterResults, setfilterResults] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const { loading, data: rejectedArtistList, refetch: refreshList } = useQuery(GET_REJECTED_ARTIST_LIST,
    { variables: { offerId, page: NUMERIC_VALUE.ONE, limit: NUMERIC_VALUE.FIVE }, fetchPolicy: 'network-only' });

  const rejectedData = rejectedArtistList?.rejectedArtist;

  useEffect(() => {
    if (rejectedData) {
      const fullData = rejectedData.data;
      setDefaultResults(fullData);
      setfilterResults(fullData);
      listingCount(OFFER_DETAIL_LISTING.REJECTED_ARTIST, fullData.length);
    } else if (rejectedData && rejectedData.count !== 0 && rejectedData.data.length === 0) {
      setDefaultResults([]);
      setfilterResults([]);
    }
  }, [rejectedData?.data]);

  useEffect(() => {
    if (searchKey !== null) {
      const lowercasedFilter = searchKey.toLowerCase();
      const filteredData = defaultResults.filter((elem) => elem.userId.name
        && (elem.userId.name.toLowerCase().includes(lowercasedFilter)));
      setfilterResults(filteredData);
    }
  }, [searchKey]);

  const renderReject = () => {
    if (filterResults.length > 0) {
      return map(filterResults, (item) => {
        const {
          basePrice, userId: {
            artistImage, name, _id, email, managerId,
          },
          rejectReason,
        } = item;
        const managerEmail = managerId && managerId.email;
        return item && (
          <div
            key={_id}
            className="request-row recommended"
          >
            <div className="image">
              <ReactImageFallback
                src={artistImage}
                fallbackImage={FALLBACK_ICON}
                className="image-cover"
                alt="artist"
              />
            </div>
            <div className="detail">
              <h4
                className="user-name"
                data-tip={email || managerEmail}
                data-place="bottom"
                data-background-color="#fff"
                data-text-color="#000"
              >
                {capitalizeEveryWord(name)}
              </h4>
              <ReactTooltip effect="solid" />
              <p>
                $
                {formatedCurrency(basePrice)}
              </p>

              <UncontrolledDropdown className="message-error-reason">
                <DropdownToggle>
                  <span className="icon icon-chat-error" />
                </DropdownToggle>
                <DropdownMenu right className="dropdown-theme">
                  <em>{`${rejectReason?.preDefined} ${rejectReason?.custom}`}</em>
                  <div className="admin-message-head-profile">
                    <span>
                      <ReactImageFallback
                        src={artistImage}
                        fallbackImage={FALLBACK_ICON}
                        className="image-cover"
                        alt="artist"
                      />
                    </span>
                    <button
                      type="button"
                      className="profile-name"
                      onClick={() => {
                        setArtistDetailModal(true);
                        setArtistDetailModalObj({ _id });
                      }}
                    >
                      View Artist’s profile
                    </button>
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
            { artistDetailModal && artistDetailModalObj && (
            <ArtistDetail
              isOpen={artistDetailModal}
              onClose={() => {
                setArtistDetailModal(!artistDetailModal);
                setArtistDetailModal(!artistDetailModal);
              }}
              userId={artistDetailModalObj._id}
              key={Math.random()}
            />
            ) }
          </div>
        );
      });
    }
    return null;
  };

  const handleLoadMoreData = () => {
    const page = currentPage + NUMERIC_VALUE.ONE;
    setCurrentPage(page);
    refreshList({
      page,
      offerId,
      limit: NUMERIC_VALUE.FIVE,
    });
  };

  return (
    <>
      {filterResults.length > 0 && (
      <div className="recommended-artist">
        <span
          id="offerRejected"
          className={`collapse-head ${collapseRejectedClass ? 'collapsed' : ''}`}
          onClick={() => { setRejectedCollapseClass(!collapseRejectedClass); }}
        >
          Opportunity rejected (
          {rejectedData?.count }
          )
        </span>
        <UncontrolledCollapse toggler="offerRejected">
          {renderReject()}
          {(rejectedData?.hasNextData) && (
            <div className="request-row recommended">
              <div className="detail">
                <h4
                  className="user-name"
                  data-place="bottom"
                  data-background-color="#fff"
                  data-text-color="#000"
                >
                  <u onClick={() => !loading && handleLoadMoreData()}>
                    Load More

                  </u>
                </h4>
              </div>
            </div>
          )}
        </UncontrolledCollapse>
      </div>
      )}
    </>
  );
}

RejectedArtistList.propTypes = {
  offerId: PropTypes.string.isRequired,
  searchKey: PropTypes.string,
  listingCount: PropTypes.func.isRequired,
};

RejectedArtistList.defaultProps = {
  searchKey: null,
};

export default React.memo(RejectedArtistList);
